import _taggedTemplateLiteralLoose from '@babel/runtime/helpers/taggedTemplateLiteralLoose';
import { css } from '@emotion/css';

var _templateObject;
var popperStyles = css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  &[data-popper-placement='top'] .MuiTooltip-arrow::before {\n    margin-top: -1px;\n  }\n  &[data-popper-placement='bottom'] .MuiTooltip-arrow::before {\n    margin-top: 1px;\n  }\n  &[data-popper-placement='left'] .MuiTooltip-arrow::before {\n    margin-inline-start: -1px;\n  }\n  &[data-popper-placement='right'] .MuiTooltip-arrow::before {\n    margin-inline-start: 1px;\n  }\n"])));

export { popperStyles };
//# sourceMappingURL=styles.js.map
